import React, { useState, useEffect } from "react";
import NewsListSkeleton from "./skeleton";
import "./news.scss";

const NewsList = ({ inforData }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (inforData.length) {
      setData(inforData);
      setLoading(false);
    }
  }, [inforData]);
  const toDetail = (record) => {
    if (record.informationId) {
      const params = new URLSearchParams({
        id: record.informationId,
      });
      const url = `/industry_detail?${params.toString()}`;
      window.open(url, "_blank");
    }
  };

  // 假设数据已经按照左中右分好，如果没有需要先处理数据
  const leftNews = data.slice(0, 2); // 左侧两条
  const centerNews = data.slice(2, 3); // 中间一条
  const rightNews = data.slice(3, 7); // 右侧四条

  if (loading) {
    return <NewsListSkeleton />;
  }
  return (
    <div className="news-container">
      {/* 左侧列 */}
      <div className="news-column left-column">
        {leftNews.map((item, index) => (
          <div key={index} className="news-card" onClick={() => toDetail(item)}>
            <img src={item.cover} alt={item.title} className="news-image" />
            <div className="news-info">
              {/* <div className="news-category">{item.category || "金融财经"}</div> */}
              <h3 className="news-title">{item.title}</h3>
              {/* <div className="news-source">
                <span className="source-name">
                  {item.source || "地球知识局"}
                </span>
                <span className="view-count">{item.views || "2"}</span>
                <span className="comment-count">{item.comments || "9"}</span>
              </div> */}
            </div>
          </div>
        ))}
      </div>

      {/* 中间列 */}
      <div className="news-column center-column">
        {centerNews.map((item, index) => (
          <div
            key={index}
            className="news-card large"
            onClick={() => toDetail(item)}
          >
            <img src={item.cover} alt={item.title} className="news-image" />
            <div className="news-info">
              {/* <div className="news-category">{item.category || "金融财经"}</div> */}
              <h3 className="news-title">{item.title}</h3>
              {/* <p className="news-desc">
                {item.description || "普通人还能继续持有美债？"}
              </p> */}
            </div>
          </div>
        ))}
      </div>

      {/* 右侧列 */}
      <div className="news-column right-column">
        <div className="column-header">近期热点</div>
        {rightNews.map((item, index) => (
          <div
            key={index}
            className="news-card small"
            onClick={() => toDetail(item)}
          >
            <div className="news-info">
              {/* <div className="news-tag">{item.label || "原创"}</div> */}
              <h3 className="news-title">{item.title}</h3>
              <div className="news-source">
                {" "}
                {item.label &&
                  item.label.split(",").map((label, i) => (
                    <span key={i} className="label-item">
                      {label}
                    </span>
                  ))}
              </div>
            </div>
            <img src={item.cover} alt={item.title} className="news-thumbnail" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewsList;
